import { useEffect, useState } from 'react';

const AdSenseAd = () => {
  const [adStatus, setAdStatus] = useState('loading');

  useEffect(() => {
    const loadAd = () => {
      try {
        if (!window.adsbygoogle) {
          throw new Error('AdSense script not loaded');
        }
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        setAdStatus('loaded');
      } catch (e) {
        setAdStatus('error');
      }
    };
    loadAd();

    const timeout = setTimeout(() => {
      const adElement = document.querySelector('.adsbygoogle') as HTMLElement | null;
      if (adElement && !adElement.style.height) {
        setAdStatus('not-rendered');
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="ad-container flex flex-col items-center">
      {adStatus === 'loading' && <p className="text-gray-400">Loading ad...</p>}
      {adStatus === 'error' && <p className="text-red-400">Ad failed to load.</p>}
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8270387450450968"
        data-ad-slot="6242808867"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdSenseAd;
